import { render } from "./full-width-story.vue?vue&type=template&id=68d68bfe"
import script from "./full-width-story.vue?vue&type=script&lang=js"
export * from "./full-width-story.vue?vue&type=script&lang=js"

import "./full-width-story.vue?vue&type=style&index=0&id=68d68bfe&lang=scss"

import exportComponent from "/Users/ashley.eastham/Fostr Dev/stephen-webster/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__